import React, {Component} from 'react';
import Header from "./header";
import "./homePage.css";
import Slider from "react-slick";
import Footer from "./footer";
import Articles from "../articles/articles";
import { Responsive, Container, Grid, Image } from 'semantic-ui-react';
import HistoryItem from "./historyitem";
import FacebookProvider, { Page } from 'react-facebook';
import YouTube from 'react-youtube';
import REV1 from './img/rev1.png';
import REV2 from './img/rev2.png';
import REV3 from './img/rev3.png';
import CoreValues from './img/core.jpg';
import HistoryData from "./data/history.json";
class RegularElderlyVisit extends Component {

  componentWillMount(){


  }

  render() {
    return (
      <div className="Homepage">

        <Header page="aboutus"/>

          <div className="homeContentWhite">
            <a id="overview">
              <Container>
                <div className="AboutUsTitle">
                  獨居長者定期配對探訪
                </div>
                <div className="AboutUsImage">
                  <Image className="AboutUsImage" src={REV1} />
                </div>
                <div className="AboutUsText left">
                「中區扶輪社」X「跑去你屋企」伙拍「香港聖公會西環長者綜合服務中心」
<br/><br/>
由二零一六年三月十九日開始，我社 聯同前社長盧偉民創立的組織 - 跑去你屋企 以及我們的社區服務伙伴 – 香港聖公會西環長者綜合服務中心開辦了這個定期配對探訪活動，它本著「重複配對探訪 」的理念，訪者與受訪者皆能為自己生命路上的同行者、學習人生智慧，大家在平等的關係下建立長久友誼關係，𢹂手締造有「家」、有「愛」的人生。
                </div>
                <div className="AboutUsImage">
                  <Image className="AboutUsImage" src={REV2} />
                </div>
<div className="AboutUsText left">
我們雖然不是長者的家人，但在持續探訪過程裏，有可能我們比他們的家人見得更緊密。
<br/><br/>
<u>義工分享 : </u>
<br/><br/>
中區扶輪社前社長 - <b>Kenny Lee</b>
<br/><br/>
「同行與陪伴」- 忘掉我是服務者，她/他是受者，三個月見一次面，短短相聚，像老朋友般分享，一點小小的讚美，已讓她們變得眉開眼笑！對我們自己，我們的角色也不就是一個過客，完了服務日，然後又是我們多姿多彩的生活；但對他們而言，在獨居的最後一段生命旅程，我們可能是他們很重要的心靈支持者。
<br/><br/>
                </div>
                <div className="AboutUsImage">
                  <Image className="AboutUsImage" src={REV3} />
                </div>
                <div className="AboutUsText left">
                跑去你屋企 – <b>Amy Cheng</b>
<br/><br/>
「好靚呀! 好靚呀!!」伯伯收到中秋探訪時的合照即高呼起來…
一張全家幅、一個相架、一個家… 再加上一個家… …

記得事情應該由暑假時一個親子活動開始…

一個炎夏的星期六早上，十多個家庭聚在一起，令平常安靜的辦公室變得熱鬧起來。大小朋友經過熱身和聆聽講解後，各位爸媽先領取物資，小孩子運用天賦的創意和美感，用小手將一塊又一塊拼貼圖樣小心奕奕地貼上小木架上。一個陽光普照的早上就在叫喊聲和歡呼聲中渡過，十多個家庭離開辦公室時，所有人的雙


                  眼都離不開剛製作完成的美麗相架。
<br/><br/>
一個天陰的秋日周六早上，數十位來自不同家庭的朋友，經過社工姑娘的簡介後，帶著月餅、提著剛摺好的紅燈籠跑到獨居的老友記屋企去。一路雨點或大或小的打在各人身上。各人穿梭西環區各新舊樓房近兩小時後，扶老攜幼去探訪的朋友都帶著濕了的雨傘，甚至穿著濕透了的外衣回到社區中心。他們從變涼、變冷的街上，帶回一個滿載陽光笑容相片的手機。所有人離開中心時，心中都記著為老友記拍下的合照何時可晒成照片。
<br/><br/>
一陽光普照的冬日周六早上，十多個放好了合照的自製相架，整裝待發。十多個家庭再次聚首，滿有期待地找回親手做的相架、尋回數月前跟老友記拍下的合照。一聲令下，各人都急不及待再一次跑上獨居老友記屋企。
<br/><br/>
啪啪啪… 啪啪啪… 「陳伯伯在嗎？喺我哋呀！」
<br/><br/>
「伯伯，你睇！鍾唔鍾意呀？」遞上相架給陳伯。
<br/><br/>
「好靚呀! 好靚呀!!」陳伯收到中秋探訪時的合照即高呼起來。見客廳電視機上的空位，一張陳伯和探訪家庭的合照，便成為這個家的一部份。陳伯一邊不斷重複著：好靚呀!好靚呀!!一邊跟探訪家庭分享自己珍藏的家庭照。
<br/><br/>
啪啪啪… 啪啪啪… 「陳婆婆在嗎？喺我哋呀！」
<br/><br/>
「婆婆，你睇！鍾唔鍾意呀？」遞上相架給陳婆婆。
<br/><br/>
「啊！係上次影既相？好靚呀！小朋友長高了。」陳婆婆執緊相架，放近眼前細看，談笑自若的說了很多後，將相架放好在客廳當眼處。探訪家庭回頭一看，家中並沒有太多陳婆婆的生活照或家庭照。
<br/><br/>
一張全家幅、一個相架、一個家… 再加上一個家… … 一張張平常不過的合照，連繫了一個又一個家；這個連結會繼續伸延出去。
<br/><br/>
</div>
              </Container>
            </a>
          </div>

        <Footer/>
      </div>
    );
  }
}

export default RegularElderlyVisit;
